webpackJsonp([38109697560938],{

/***/ 533:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mitchell Kansas Tesla Blog","author":"Ryan Mitchell"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2019-03-04-should-we-blog-again/index.md absPath of file >>> MarkdownRemark","html":"<p>We’re getting ready for Spring Break. Should we blog again?</p>","frontmatter":{"title":"We might need to start blogging again","date":"March 04, 2019","author":"mitch"}}},"pathContext":{"slug":"/2019-03-04-should-we-blog-again/","previous":{"fields":{"slug":"/2018-06-26-mitch-charging-costs/"},"frontmatter":{"title":"Charging costs","author":"mitch"}},"next":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---2019-03-04-should-we-blog-again-eeb4f5c7c018c36a4d46.js